module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/1_0382505d82ce0a3cc0badea4f0f95071.png";